<template>
  <!-- name: '首页' -->
  <div class="homeWrap">
    <img src="https://img.bbalt.cn/imgh5/home/logo.png" alt="logo" class="logoClass" />
    <SwiperBanner :bannerList="bannerList" />
    <div class="amountBox">
      <div class="crodBox">
        <img src="https://img.bbalt.cn/imgh5/home/icon_crod.svg" alt="" />
        <img src="https://img.bbalt.cn/imgh5/home/icon_crod.svg" alt="" />
      </div>
      <div class="numberBox">
        <span class="heartClass"></span>
        <span class="numberClass">已有<span class="redColor">{{ amount }}</span>份爱心被精确认领</span>
        <span class="heartClass"></span>
      </div>
    </div>
    <ul class="buttonBox">
      <li @click="$router.push({ path: '/other', query: { title: '关于我们' } })">
        <span>关于我们</span>
        <span>了解宝贝爱蓝天</span>
        <img src="https://img.bbalt.cn/imgh5/home/btn_about.png" alt="" />
      </li>
      <li @click="
        $router.push({ path: '/other', query: { title: '捐赠/申领须知' } })
        ">
        <span>捐赠申领须知</span>
        <span>关注必看</span>
        <img src="https://img.bbalt.cn/imgh5/home/btn_info.png" alt="" />
      </li>
      <li @click="$router.push({ path: '/other', query: { title: '支持我们' } })">
        <span>支持我们</span>
        <span>了解宝贝爱蓝天</span>
        <img src="https://img.bbalt.cn/imgh5/home/btn_sup.png" alt="" />
      </li>
    </ul>
    <div class="titleClass">
      正在募集
      <img src="https://img.bbalt.cn/imgh5/icon_arrow.svg" @click="handleMore()" />
    </div>
    <van-loading v-if="isShow">加载中...</van-loading>
    <div v-else>
      <ul class="collectBox" v-show="collectList.length > 0">
        <li v-for="(item, index) in collectList" :key="index" @click="
          $router.push({
            path: '/donateThird',
            query: { title: '项目详情', id: item.id, nextPath: '/home' },
          })
          ">
          <img :src="item.image" alt="" class="imgClass" />
          <div class="infoBox">
            <h5>{{ item.theme }}</h5>
            <div class="contentBox">
              <div class="labelBox">
                <span class="labelClass"><img src="https://img.bbalt.cn/imgh5/home/icon_place.svg" />{{
                  item.province
                  }}</span>
                <span class="labelClass" v-show="item.type === 1"><img
                    src="https://img.bbalt.cn/imgh5/home/icon_size.svg" />{{
                      item.minHeight
                    }}-{{ item.maxHeight }}CM</span>
              </div>
              <span class="lackNumClass">缺{{ item.lackCount }}件</span>
            </div>
            <div class="progressBox">
              <div class="progressClass" :style="`width:${(item.donatedCount / item.totalCount) * 100}%`"></div>
            </div>
          </div>
        </li>
      </ul>
      <div class="noDataBox" v-show="collectList.length === 0">
        <img src="https://img.bbalt.cn/imgh5/nodata.png" alt="" />
        暂无数据
      </div>
    </div>
    <div class="titleClass">
      捐赠反馈
      <img src="https://img.bbalt.cn/imgh5/icon_arrow.svg" @click="handleMore()" />
    </div>
    <van-loading v-if="isShow">加载中...</van-loading>
    <div v-else>
      <ul class="feedbackBox" v-show="feedbackList.length > 0">
        <li v-for="(item, index) in feedbackList" :key="index" @click="
          $router.push({
            path: '/donateThird',
            query: {
              title: '项目详情',
              id: item.id,
              type: '项目反馈',
              nextPath: '/home',
            },
          })
          ">
          <img :src="item.image" alt="" class="imgClass" />
          <h5>{{ item.theme }}</h5>
          <div class="infoBox">
            <span class="labelClass"><img src="https://img.bbalt.cn/imgh5/home/icon_place.svg" />{{
              item.province
              }}</span>
            <span class="numberClass">已捐 {{ item.donatedCount }} 件 / 募集 {{ item.days }} 天</span>
          </div>
        </li>
      </ul>
      <div class="noDataBox" v-show="feedbackList.length === 0">
        <img src="https://img.bbalt.cn/imgh5/nodata.png" alt="" />暂无数据
      </div>
    </div>

    <div class="footClass" v-show="footShow && (collectList.length > 0 || feedbackList.length > 0)">
      已经到底啦～
    </div>
  </div>
</template>

<script>
import SwiperBanner from "@/components/SwiperBanner.vue";
import { home, qrLoginApi, updateInviteCodeApi } from "@/api/home";
import mixin from "@/utils/mixin.js";
import { getToken } from "@/utils/localToken.js";
export default {
  mixins: [mixin],
  components: { SwiperBanner },
  data() {
    return {
      bannerList: [],
      amount: 0,
      collectList: [],
      feedbackList: [],
      footShow: false,
      isShow: true,
      inviteCode: this.$route.query.inviteCode,
      code: this.$route.query.code
    };
  },
  async created() {
    await this.getAndSetToken();
    await this.getHome();
  },
  methods: {
    async init() {
      let token = getToken()
      alert('token=' + token)
      alert('code=' + this.code)
      if (getToken() != null) {
        // 更新inviteCode
        if (this.inviteCode != null) {
          const params = { inviteCode: this.inviteCode}
          const { code } = updateInviteCodeApi(params)
          if (code !== 200) {
            this.$toast.fail('更新邀请码失败，请联系管理员')
          }
        }
      } else {
        if (this.code != null) {
          window.location.href = '/invite/doLogin?inviteCode=' + this.inviteCode + '&code=' + this.code
        }
      }
    },
    async getHome() {
      const { code, content } = await home();
      if (code === 200) {
        this.bannerList = content.topImgs;
        this.amount = content.numberOfLove;
        this.feedbackList = content.feedbackList;
        this.collectList = content.demandInfoList;
        this.isShow = false;
      }
    },
    handleMore() {
      localStorage.removeItem("curSelectTab");
      this.$nextTick(() => {
        this.$router.push({
          path: "/donateSecond",
          query: { title: "我要捐衣物", curSelectTab: "捐衣" },
        });
      });
    },
    // 获取url上的token，将token写入本地缓存
    getAndSetToken() {
      if (this.$route.query.hasMobile === "false") {
        this.$router.replace({ path: "/login" });
      }
    },
  },
  mounted() {
    let dom = document.querySelector(".homeWrap");
    let _this = this;
    dom.addEventListener(
      "scroll",
      this.throttle(function () {
        const scrollDistance =
          dom.scrollHeight - dom.scrollTop - dom.clientHeight;
        if (scrollDistance < 1) {
          _this.footShow = true;
        } else {
          _this.footShow = false;
        }
      })
    );
  },
  activated() {
    if (this.$route.query.forceRefresh) {
      this.getHome();
      this.$route.query.forceRefresh = false;
    }

  }
};
</script>

<style lang="scss" scoped>
.homeWrap {
  height: calc(100% - 100px);
  width: 100%;
  background: linear-gradient(135deg, #fbf0f6, rgba(255, 255, 255, 0) 30%),
    linear-gradient(215deg, #e9f1f8, rgba(255, 255, 255, 0) 30%),
    linear-gradient(180deg, #fff, #fff 45%);
  text-align: center;
  overflow: auto;
  padding-bottom: 37px;

  .logoClass {
    width: calc(180vw * $vw);
    margin: 20px auto;
  }

  .amountBox {
    width: 686px;
    height: 96px;
    background: #ffffff;
    border-radius: 16px;
    border: 1px solid #dddddd;
    margin: 24px auto;
    position: relative;

    .crodBox {
      position: absolute;
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding: 0px 36px;

      img {
        margin-top: -16px;
        width: 40px;
        height: 40px;
      }
    }

    .numberBox {
      position: absolute;
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;

      .heartClass {
        position: relative;
        top: 12px;
        width: 12px;
        height: 12px;
        background-color: #333;
        transform: rotate(-135deg);
        margin-top: -12px;

        &::before {
          content: "";
          position: absolute;
          top: 6px;
          left: 0px;
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background-color: #333;
        }

        &::after {
          content: "";
          position: absolute;
          top: 0px;
          left: 6px;
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background-color: #333;
        }
      }

      .numberClass {
        margin: 0px 24px;

        .redColor {
          color: #fe66a6;
          margin: 0px 18px;
          font-size: 44px;
        }
      }
    }
  }

  .buttonBox {
    margin: 0px 32px;
    display: flex;
    justify-content: space-between;

    li {
      width: 218px;
      height: 180px;
      background: #f5f5f5;
      border-radius: 16px;
      position: relative;
      padding-top: 24px;

      span {
        font-family: PingFangSC-Regular, PingFang SC;
        width: 100%;
        display: inline-block;
        text-align: left;
        padding-left: 20px;

        &:first-child {
          font-size: 28px;
          font-weight: 600;
          color: #333333;
          height: 36px;
          line-height: 36px;
        }

        &:nth-child(2) {
          font-size: 24px;
          font-weight: 400;
          color: #999999;
          height: 32px;
          line-height: 32px;
        }
      }

      img {
        width: 80px;
        height: 80px;
        position: absolute;
        right: 0px;
        bottom: 0px;
      }
    }
  }

  .titleClass {
    font-size: 36px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 46px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 32px;
    margin-top: 64px;

    img {
      width: 30px;
      height: 30px;
    }
  }

  .collectBox {
    width: 100%;
    padding: 0px 22px;
    display: flex;
    flex-flow: column;

    li {
      margin: 24px auto;
      display: flex;

      .imgClass {
        width: 240px;
        height: 148px;
        background: #f5f5f5;
        border-radius: 16px;
        margin-right: 16px;
      }

      .infoBox {
        width: 430px;

        h5 {
          width: 100%;
          height: 80px;
          font-size: 30px;
          font-family: PingFang-SC-Bold, PingFang-SC;
          font-weight: bold;
          color: #333333;
          line-height: 40px;
          text-align: left;
        }

        .contentBox {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 10px;

          .labelBox {
            display: flex;
          }

          .lackNumClass {
            height: 28px;
            font-size: 22px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #679fd2;
            line-height: 28px;
            display: inline-block;
            min-width: 80px;
          }
        }

        .progressBox {
          width: 100%;
          height: 12px;
          background: #f5f5f5;
          border-radius: 16px;
          margin-top: 16px;
          position: relative;

          .progressClass {
            position: absolute;
            height: 100%;
            background: #fe74ae;
            border-radius: 16px;
            display: inline-block;
            // width: 66%;
            top: 0px;
            left: 0px;
          }
        }
      }
    }
  }

  .feedbackBox {
    width: 100%;
    margin-top: 42px;
    display: flex;
    flex-flow: column;

    li {
      width: calc(100% - 64px);
      min-height: 456px;
      border-radius: 16px;
      border: 1px solid #dddddd;
      margin: auto;
      margin-bottom: 24px;
      padding-bottom: 31px;
      display: flex;
      flex-flow: column;
      background-image: url("https://img.bbalt.cn/imgh5/home/feedback_bg.svg");
      background-repeat: no-repeat;
      background-position: 100% 122%;
      background-size: 225px 224px;

      .imgClass {
        width: 100%;
        height: 316px;
        border-radius: 16px 16px 0px 0px;
        margin-bottom: 24px;
      }

      h5 {
        width: 100%;
        min-height: 40px;
        font-size: 30px;
        font-family: PingFang-SC-Bold, PingFang-SC;
        font-weight: bold;
        color: #333333;
        line-height: 40px;
        text-align: left;
        padding: 0px 24px 0px 32px;
      }

      .infoBox {
        margin-top: 24px;
        display: flex;
        justify-content: flex-start;
        padding-left: 32px;
        align-items: center;
        margin-bottom: 31px;

        .numberClass {
          height: 28px;
          font-size: 22px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #679fd2;
          line-height: 28px;
          padding-left: 24px;
        }
      }
    }
  }

  .labelClass {
    padding: 0px 8px;
    min-height: 30px;
    line-height: 30px;
    background: #679fd2;
    border-radius: 4px;
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 110px;
    width: auto;
    margin-right: 8px;
    text-align: start;

    img {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
  }

  .footClass {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 32px;
    margin-top: 50px;
  }
}

.noDataBox {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;

  img {
    width: 80%;
    margin: 30px auto;
  }
}
</style>
